/* @ngInject */
export default function FormatPartFilter() {
    return function (pn) {
        return pn.replace(/(\{[^;]*})/gi, '');
    };
}
